import { render, staticRenderFns } from "./AplicaPersonalVuelo.vue?vue&type=template&id=5afffce6&scoped=true&"
import script from "./AplicaPersonalVuelo.vue?vue&type=script&lang=js&"
export * from "./AplicaPersonalVuelo.vue?vue&type=script&lang=js&"
import style0 from "./AplicaPersonalVuelo.vue?vue&type=style&index=0&id=5afffce6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afffce6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})
